import React, {Component} from 'react'

const ALL_INDICATOR = "ALL";

class ItemFilter extends Component {

    setFilterSearchText(filterValue) {

        if (filterValue.trim() === '') {
            this.props.filter.searchText = null;
        } else {
            this.props.filter.searchText = filterValue;
        }
    }

    setFilterCompany(company) {
        this.props.filter.company = company;
        this.props.onFilter();
    }

    setFilterCategory(category) {
        this.props.filter.category = category;
        this.props.filter.company = ALL_INDICATOR;
        this.props.onSelectCategory();
        this.props.onFilter();
    }

    keyPressed(event) {
        if (event.key === "Enter") {
            this.props.onFilter();
        }
    }


    render() {
        return <div className="input-group mb-3 container-fluid item-filter">

            <div name="filter-search" key="filter-search">
                <label htmlFor="filter">Search:</label>

                <input onKeyDown={event => this.keyPressed(event)}
                       onChange={event => this.setFilterSearchText(event.target.value)} type="text"
                       id="filter-search-text"
                       name="filter-search-text">
                </input>

                <button onClick={this.props.onFilter} className="filter-search-button btn btn-primary btn-sm">Search
                </button>
            </div>
            <div className="categorySelector" key="categorySelector">
                <label htmlFor="categorySelector">Category:</label>

                {this.props.categories.map(categoryName =>
                    <>
                        <br/>
                        <label>
                            <input type="radio" id={categoryName} name="categorySelectorEntry" value={categoryName}
                                   checked={categoryName === this.props.filter.category}
                                   onChange={event => this.setFilterCategory(event.target.value)}/>
                            <span className="non-wrappable">{categoryName}</span>
                        </label>
                    </>
                )
                }

            </div>

            <label htmlFor="companySelector">Company:</label>

            <select onChange={event => this.setFilterCompany(event.target.value)} name="companySelector"
                    id="companySelector" className="companySelector" data-testid="companySelector">
                {this.props.companies.map(companyName =>
                    <option value={companyName} key={companyName}
                            selected={companyName === this.props.filter.company}>{companyName}</option>
                )
                }
            </select>

            <div className="filter-actions non-wrappable">

                <button onClick={this.props.onResetFilter} data-testid="filter-reset-button"
                        className="btn btn-primary btn-sm filter-reset-button">Reset
                    search
                </button>

                <br/>
            </div>

            <div className="filter-result">
                <span className="found-items"> Found items: {this.props.numberOfItems}</span>
            </div>
        </div>
    }
}


export default ItemFilter;